module.exports = "//static.hsappstatic.net/website-grader-ui/static-1.8744/img/mobile-onboarding-powering-up.svg"